import { DeliverymanFormMain } from '@/_features/motoboys/deliveryman-form';

function DeliverymanForm() {
  return (
    <div className="container">
      <DeliverymanFormMain />
    </div>
  );
}

export default DeliverymanForm;
